import _ from "lodash";
import {
  cvOutputData,
  getCareerAvailableYears,
  sectionSort
} from "../lib/cvDataUtilities.js";
import {
  day,
  getDate,
  getYears,
  isTimeWithinRange,
  zeroPad
} from "../lib/dateHelpers.js";
import { previewSections } from "../lib/formatUtilities.js";
import { escapeHtml, getProp } from "../lib/frontendUtilities.js";
import { getLastPosition } from "../lib/reportUtilities.js";
import { empty, getField, getKey, keys } from "../lib/utilities.js";
import { CCManage } from "./cclib/CCManage.ts";

var sortBy = "mentor";
var mentees = [];

var buStructure = [
  {
    type: "select",
    key: "track",
    options: ["Clinical Modified", "Unmodified"]
  },
  { name: "Reporting Vice Chair", type: "string", key: "report_to" },
  {
    name: "Annual Clinical Hours",
    type: "integer",
    key: "annual_clinical_hours"
  },
  { name: "Main mentor", type: "string", key: "main_mentor" },
  { name: "Other mentors", type: "string", key: "other_mentors" },
  { name: "1) SUMMARY", type: "header" },
  { name: "Year of hire", type: "integer", key: "year_hire" },
  {
    name: "Years post residency",
    type: "extraction",
    key: "years_post",
    val: function (newDef) {
      var facultyAppointments = _.orderBy(
        getField(newDef, "postDoctoralTraining"),
        sectionSort({})
      );
      var lastResidency = null;
      for (var i = facultyAppointments.length - 1; i >= 0; i--) {
        var item = facultyAppointments[i];
        var title = (item.title || "").toLowerCase();
        if (title.indexOf("residen") >= 0) {
          lastResidency = item;
          break;
        }
      }

      var yearsPost = "?";
      if (
        lastResidency != null &&
        lastResidency.time != null &&
        !empty(lastResidency.time.start)
      ) {
        yearsPost = Math.round(
          (Date.now() -
            (lastResidency.time.end != null &&
            lastResidency.time.end != "ongoing"
              ? getYears(lastResidency.time.end, { limitOngoing: true })
              : getYears(lastResidency.time.start, { limitOngoing: true }))) /
            (day * 365)
        );
      }

      return {
        text: yearsPost,
        field: "postDoctoralTraining",
        i: (lastResidency || {}).i
      };
    }
  },
  { name: "FTE (0.1 - 1)", type: "float", key: "fte" },
  { name: "Effort: Total weekly hours", type: "header" },
  { name: "Clinical", type: "integer", key: "effort_clinical" },
  { name: "Education", type: "integer", key: "effort_teaching" },
  { name: "Administration", type: "integer", key: "effort_admin" },
  { name: "Research", type: "integer", key: "effort_research" },
  {
    name: "Mentorship needed based on content or expertise:",
    type: "paragraph",
    key: "mentorship_needed"
  },
  {
    name: "Mission Statement (professional and personal purpose):",
    type: "paragraph",
    key: "mission"
  },
  { name: "2) SELF ASSESSMENT AND GOALS (PAST YEAR)", type: "header" },
  { name: "Clinical", type: "header" },
  {
    name: "How satisfied are you with your CLINICAL PERFORMANCE",
    type: "select",
    key: "clinical_satisfaction",
    options: ["Very Satisfied", "Somewhat Satisfied", "Dissatisfied"]
  },
  {
    name: "List one change that you would make in your CLINICAL WORK in the upcoming year:",
    type: "paragraph",
    key: "clinical_change"
  },
  { name: "Education", type: "header" },
  {
    name: "How satisfied are you with your RESIDENT/APP/Fellow EDUCATION",
    type: "select",
    key: "teaching_resident_satisfaction",
    options: ["Very Satisfied", "Somewhat Satisfied", "Dissatisfied"]
  },
  {
    name: "How satisfied are you with your STUDENT EDUCATION",
    type: "select",
    key: "teaching_student_satisfaction",
    options: ["Very Satisfied", "Somewhat Satisfied", "Dissatisfied"]
  },
  {
    name: "List one change that you would make in your educational contributions in the upcoming year:",
    type: "paragraph",
    key: "teaching_change"
  },
  { name: "Scholarship/Academics/Promotion", type: "header" },
  {
    name: "Based on your CV, how satisfied are you with your scholarly work (publications and presentations)",
    type: "select",
    key: "scholarship_satisfaction",
    options: ["Very Satisfied", "Somewhat Satisfied", "Dissatisfied"]
  },
  {
    name: "List one change that you would make in your SCHOLARLY WORK:",
    type: "paragraph",
    key: "scholarly_change"
  },
  {
    name: "Do you feel that you are on track for PROMOTION",
    type: "select",
    key: "scholarship_track",
    options: ["Yes", "No", "N/A"]
  },
  {
    name: "List one change that you would like to make in your promotion activity for the upcoming year:",
    type: "paragraph",
    key: "promotion_change"
  },
  { name: "Vitality", type: "header" },
  {
    name: "What is your level of enthusiasm for your job",
    type: "select",
    key: "vitality_enthusiasm",
    options: ["High", "Medium", "Low"]
  },
  {
    name: "Are you concerned about burnout/high stress or non-sustainability of your work",
    type: "select",
    key: "vitality_concern",
    options: ["Yes", "No"]
  },
  { name: "Comments:", type: "paragraph", key: "vitality_comments" },
  { name: "Career Development/Goals", type: "header" },
  {
    name: "Did you meet your <b>goals from last year</b>",
    type: "select",
    key: "career_goals_met",
    options: ["Yes", "No"]
  },
  {
    name: "Any followup from Vice Chair meeting:",
    type: "paragraph",
    key: "career_vice_chair_followup"
  },
  {
    name: "If no, please describe barriers:",
    type: "paragraph",
    key: "career_describe_barriers"
  },
  {
    name: "Do you feel you need leadership development or training in a specific area",
    type: "select",
    key: "career_development",
    options: ["Yes", "No"]
  },
  { name: "If so, describe:", type: "paragraph", key: "career_describe" },
  {
    name: "SMART GOALS for upcoming year (Specific, Measurable, Achievable, Relevant and Time Bound). List up to 3:",
    type: "paragraph",
    key: "career_short_goals"
  },
  {
    name: "List 1-2 Long term goals:",
    type: "paragraph",
    key: "career_long_goals"
  },
  { name: "DEI", type: "header" },
  {
    name: "Please list your contributions to DEI over the past year:",
    type: "paragraph",
    key: "dei"
  },
  {
    name: "Personal Statement:",
    type: "paragraph",
    key: "personal",
    wordLimit: 750
  },
  { html: '<span id="buConfPreview"></span>', type: "html" },
  { name: "ADDITIONAL INFORMATION/QUESTIONS", type: "header" },
  {
    name: "Describe any activities that you wish to highlight that have not been described. Is there any other information you would like us to know about you?",
    type: "paragraph",
    key: "additional_activities"
  },
  {
    name: "Are there any other specific topics you would like to discuss at this meeting?",
    type: "paragraph",
    key: "additional_topics"
  },
  {
    name: 'I have filled out my annual faculty review information for the medical school (found at <a href="https://protect-us.mimecast.com/s/jK13CyP5MgfWw90kiZc6k1?domain=bumc.bu.edu" target="_blank">https://protect-us.mimecast.com/s/jK13CyP5MgfWw90kiZc6k1?domain=bumc.bu.edu</a>)',
    type: "check",
    key: "additional_medical"
  },
  {
    name: "I have reviewed my faculty letter describing compensation and responsibilities",
    type: "check",
    key: "additional_reviewed"
  },
  {
    name: "The Department of Emergency Medicine has policies and procedures which describe important information to all faculty, APP, and staff. The departmental policies are communicated out to these groups via email, presented at meetings, and stored at the “EM Dept Policies” OneDrive file. Policies include information regarding Moonlighting, CME, Paid Time Off and Pro-rating Overnight, Weekend, Holiday and On-Call. These policies are subject to change and updates will be sent to the department. It is the Department’s expectation that all members are aware of and read these policies and procedures. If I have any questions, I will reach out to Anthony Ho. I have read and understand this expectation.",
    type: "check",
    key: "policies_and_procedures_agreed"
  },
  {
    name: "I plan to meet with my chair for my Annual Review in 2024",
    type: "check",
    key: "plan_to_meet_with_chair_agreed"
  }
];

export default {
  title: "BU",
  tabTitle: "Annual Review",
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    let { updateLayout, checkSave } = contextMethods;
    let { user, cvOwner, mentors, formats } = contextConstants;
    let {
      section,
      sectionState,
      format,
      newDef,
      viewAsState,
      customExportSettings
    } = contextState;

    var editAccessOverride =
      (user.settings.accessFilters || []).length > 0 &&
      user.settings.conferenceTabAccess === "editAccess";
    var menteeOverride = false;
    var mentorOverride = false;

    var menteeAccess =
      user.id === cvOwner.id || editAccessOverride || menteeOverride;
    var overviewState = getKey(sectionState, section, {});

    var mentorAccess =
      (conference.mentors[user.id] || {})[cvOwner.id] != null ||
      editAccessOverride ||
      mentorOverride;

    var managerAccess = editAccessOverride;

    $("#fieldList").empty();

    $("#fieldList").append(
      $(
        "" +
          "<div>" +
          '   <div class="btn btn-default careerYearPrev" style="margin-right: 15px; margin-bottom: 8px;">' +
          '   <span class="glyphicon glyphicon-arrow-left"></span>' +
          "   </div>" +
          '   <h4 class="careerYear" style="margin-right: 15px;display: inline-block;margin-top: 7px;vertical-align: top;">Year: </h4>' +
          '   <div class="btn btn-default careerYearNext" style="margin-right: 15px;vertical-align: top;"><span class="glyphicon glyphicon-arrow-right"></span></div>' +
          '   <div class="btn btn-primary limitedCVCareerDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Date Limited CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary fullDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Full CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary buReviewForm" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>BU Review Form</span>" +
          "   </div>" +
          '   <div class="btn btn-primary careerReportPrint" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-print" style="margin-right: 5px;"></span>' +
          "     <span>Print</span>" +
          "   </div>" +
          '   <div class="btn btn-primary" id="copy-prior-data" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-copy" style="margin-right: 5px;"></span>' +
          "     <span>Copy prior year data</span>" +
          "   </div>" +
          " </div>"
      )
    );

    $("#copy-prior-data").click(function () {
      const overviewState = getKey(sectionState, section, {});

      const yearInfo = getCareerAvailableYears(
        newDef,
        conference,
        user,
        cvOwner
      );
      const availableYears = yearInfo.availableYears;
      const baseYear = yearInfo.baseYear;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      const viewYear = availableYears[overviewState.yearIndex];

      // const currentData = newDef.career[viewYear];
      const lastYearsData = newDef.career[viewYear - 1];
      if (!lastYearsData) {
        return;
      }

      const populateField = (fieldName) => {
        const input = $(`input[data-key="${fieldName}"]`);
        const currentVal = input.val();
        if (!currentVal) {
          const previousVal = lastYearsData.data[`bu_${fieldName}`];
          input.val(previousVal).trigger("change").trigger("input");
        }
      };

      const populateSelect = (fieldName) => {
        const input = $(`select[data-key="${fieldName}"]`);
        const currentVal = input.val();
        if (!currentVal || currentVal === "choose") {
          const previousVal = lastYearsData.data[`bu_${fieldName}`];
          input.val(previousVal).trigger("change");
        }
      };

      const populateTextArea = (fieldName) => {
        const input = $(`textarea[data-key="${fieldName}"]`);
        const currentVal = input.val();
        if (!currentVal || currentVal === "choose") {
          const previousVal = lastYearsData.data[`bu_${fieldName}`];
          input.val(previousVal).trigger("input");
        }
      };

      populateSelect("track");
      populateField("report_to");
      populateField("annual_clinical_hours");
      populateField("main_mentor");
      populateField("other_mentors");
      populateField("year_hire");
      populateField("fte");
      populateField("effort_clinical");
      populateField("effort_teaching");
      populateField("effort_admin");
      populateField("effort_research");
      populateTextArea("mentorship_needed");
      populateTextArea("mission");
    });

    if (!menteeAccess) {
      $("#copy-prior-data").remove();
    }

    $(".careerReportPrint")
      .unbind("click")
      .click(function () {
        updateHTML({ readOnly: true });
        var printContents = $("#printableContents")[0].innerHTML;
        var w = window.open("", "Test");
        if (w == null) return;
        w.document.write(
          '<link rel="stylesheet" href="/css/bootstrap.min.css"/>'
        );
        w.document.write(
          "<style> @media print {  @page { margin: 1in; } } </style>"
        );
        var yearRange = $(".careerYear").text();
        w.document.write(
          '<div style="padding: 15px;"><h4 style="">' +
            yearRange +
            " " +
            (cvOwner.name || "") +
            " Career Conference</h4>" +
            printContents +
            "</div>"
        );
        updateHTML();
        w.document.title =
          yearRange + " " + (cvOwner.name || "") + " Career Conference";
        setTimeout(function () {
          w.print();
          // w.close();
        }, 1000);
      });

    $(".limitedCVCareerDownload")
      .unbind("click")
      .click(function () {
        var overviewState = getKey(sectionState, section, {});

        var yearInfo = getCareerAvailableYears(
          newDef,
          conference,
          user,
          cvOwner
        );
        var availableYears = yearInfo.availableYears;
        var baseYear = yearInfo.baseYear;
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        )
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        var viewYear = availableYears[overviewState.yearIndex];

        var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
        var month = cutoff.split("/")[0] || "1";
        var date = cutoff.split("/")[1] || "1";

        customExportSettings.dateLimited = true;
        customExportSettings.shown = true;

        var endDate = new Date(
          viewYear + 1,
          parseInt(month) - 1,
          parseInt(date) - 1
        );
        $("#m1").val(month);
        $("#m2").val(endDate.getMonth() + 1);
        $("#d1").val(date);
        $("#d2").val(endDate.getDate());
        $("#y1").val(viewYear + (format == "stanford_anesthesia" ? -1 : 0));
        $("#y2").val(endDate.getYear() + 1900);
        $(".download").trigger("click");
      });

    var mentorList = keys(conference.mentors).filter(function (id) {
      return conference.mentors[id][cvOwner.id] != null;
    });

    if (mentorList.length > 0) {
      $("#fieldList").append(
        $(
          "" +
            '<div id="confSelectSection" style="margin-bottom: 10px;display: inline-block;width: 100%;">' +
            '  <h4 style="display: inline-block;margin-right: 5px;">Annual Review Mentor' +
            (mentorList.length > 1 ? "s" : "") +
            ": " +
            mentorList
              .map(function (mId) {
                return escapeHtml(mentors[mId].name);
              })
              .join(", ") +
            "</h4>" +
            "</div>"
        )
      );
    }

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;">Missing Information Required Before Submission</h5>' +
          '  <h5 class="statusSubheader">When finished, mark as complete to notify your mentor.</h5>' +
          "</div>"
      )
    );

    var last = getLastPosition(newDef, { format });
    if (
      last != null &&
      last.time != null &&
      last.time.start != null &&
      !isNaN(getYears(last.time.start))
    ) {
      var dateText = getDate(last);
      var yearsLong = Math.round(last.years * 10) / 10; // Math.round(((last.time.end != null && last.time.end != 'ongoing') ? getYears(last.time.end) : (new Date().getYear()+1900)) - getYears(last.time.start));
      $("#fieldList").append(
        $(
          "" +
            '<div style="margin-bottom: 10px;margin-top: 10px;">' +
            '  <h4 style="margin-bottom: 10px; display: inline-block;">Academic Title: <span id="careerConfCurrentTitle"><u class="sectionTab" data-section="facultyAppointments">' +
            escapeHtml(last.title) +
            " (" +
            escapeHtml(dateText) +
            ")</u> for " +
            yearsLong +
            " year" +
            (yearsLong != 1 ? "s" : "") +
            "</span></h4>" +
            "<div>"
        )
      );
    }

    var printableContents = $('<span id="printableContents"></span>');
    $("#fieldList").append(printableContents);

    // Find which years are available. Should be just years which have data or which are open, or if you have mentorAccess
    var yearInfo = getCareerAvailableYears(newDef, conference, user, cvOwner);
    var availableYears = yearInfo.availableYears;
    var baseYear = yearInfo.baseYear;

    var overviewState = getKey(sectionState, section, {});
    if (
      overviewState.yearIndex == null ||
      availableYears[overviewState.yearIndex] == null
    ) {
      overviewState.yearIndex = availableYears.findIndex(function (n) {
        return n === baseYear;
      });
    }

    $(".buReviewForm")
      .unbind("click")
      .click(function () {
        var template = "/templateFiles/reports/bu_career_report_v1_2.docx";
        var oReq = new XMLHttpRequest();
        oReq.open("GET", template, true);
        oReq.responseType = "arraybuffer";
        oReq.onload = function () {
          var arrayBuffer = oReq.response;
          var content = new Uint8Array(arrayBuffer);
          var zip = new PizZip(content);
          var doc = new Docxtemplater();
          doc.loadZip(zip);
          doc.setOptions({ linebreaks: true });

          var overviewState = getKey(sectionState, section, {});
          var yearInfo = getCareerAvailableYears(
            newDef,
            conference,
            user,
            cvOwner
          );
          var availableYears = yearInfo.availableYears;
          var baseYear = yearInfo.baseYear;
          if (
            overviewState.yearIndex == null ||
            availableYears[overviewState.yearIndex] == null
          )
            overviewState.yearIndex = availableYears.findIndex(function (n) {
              return n == baseYear;
            });
          var viewYear = availableYears[overviewState.yearIndex];
          var yearData = newDef.career[viewYear];

          var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
          var month = cutoff.split("/")[0] || "1";
          var date = cutoff.split("/")[1] || "1";

          var startDate = new Date(
            month + "/" + date + "/" + viewYear
          ).getTime();
          var endDate =
            new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
            1000 * 60 * 60 * 24;

          var outputSource = formats[format];
          if (formats[format].outputs != null) {
            var outputNames = keys(formats[format].outputs);
            if (outputNames.indexOf($("#cvOutputFormat").val()) >= 0)
              outputSource =
                formats[format].outputs[$("#cvOutputFormat").val()];
            else outputSource = formats[format].outputs[outputNames[0]];
          }

          cvOutputData(
            newDef,
            {
              id: cvId,
              cvOwner,
              type: "partial",
              start: { month, year: viewYear },
              end: { month, year: viewYear + 1 },
              filter: function (time) {
                return isTimeWithinRange(time, startDate, endDate);
              },
              formats,
              contextState,
              outputSource,
              custom: { dateLimited: true }
            },
            function (data) {
              buStructure.map(function (item) {
                if (item.key != null) {
                  if (item.type == "check")
                    data[item.key] = !!yearData.data["bu_" + item.key];
                  else if (item.type == "extraction")
                    data[item.key] = item.val(newDef).text;
                  else data[item.key] = yearData.data["bu_" + item.key] || "";
                }
              });

              doc.setData(data);
              try {
                doc.render();
              } catch (error) {
                console.log({
                  message: error.message,
                  name: error.name,
                  stack: error.stack,
                  properties: error.properties
                });
                throw error;
              }

              var dateString =
                new Date().getYear() +
                1900 +
                "-" +
                zeroPad(new Date().getMonth() + 1, 2) +
                "-" +
                zeroPad(new Date().getDate(), 2);
              var docFile = doc.getZip().generate({
                type: "blob",
                mimeType:
                  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              });

              var fileName =
                cvOwner.name
                  .split(",")
                  .join("")
                  .split(".")
                  .join("")
                  .split(" ")
                  .join("_") +
                "_" +
                dateString +
                "_BU_Review.docx";

              backend.send("saveLog", {
                id: user.id,
                path: window.location.pathname,
                action: JSON.stringify({
                  type: "download BU Review Form",
                  title: fileName.split("\n").join("")
                }),
                context: JSON.stringify({
                  agent: window.navigator.userAgent,
                  params: window.location.search,
                  cvId: cvId,
                  cvOwner: cvOwner.id
                })
              });

              saveAs(docFile, fileName.split("\n").join(""));
            }
          );
        };
        oReq.send();
      });

    buStructure.map(function (item) {
      if (item.type == "header") {
        printableContents.append(
          $(
            '<h5 style="margin-bottom: 10px; margin-top: 20px; font-weight: bold; text-decoration: underline;">' +
              item.name +
              "</h4>"
          )
        );
      } else if (item.type == "extraction") {
        var extracted = item.val(newDef);
        printableContents.append(
          $(
            '<h5 style="margin-bottom: 20px;">' +
              item.name +
              ': <a href="#" class="jump" data-id="' +
              extracted.id +
              '" data-field="' +
              extracted.field +
              '"><span class="confExtraction" data-key="' +
              item.key +
              '">' +
              extracted.text +
              '</span><span class="glyphicon glyphicon-share-alt" style="margin-left: 5px; cursor: pointer;"></span></a></h4>'
          )
        );
      } else if (item.type == "string") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%;">' +
              (item.name == null
                ? ""
                : '<h5 style="display: inline-block; margin-right: 10px;">' +
                  item.name +
                  ": </h5>") +
              '<input class="form-control confString" data-key="' +
              item.key +
              '" value="" style="width: 200px; display: inline-block;"></div>'
          )
        );
      } else if (item.type == "paragraph") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="display: inline-block; margin-right: 10px;" class="confParagraphTitle" data-key="' +
              item.key +
              '">' +
              item.name +
              ' </h5><textarea class="form-control confParagraph" data-key="' +
              item.key +
              '" style="width: 100%; display: inline-block;"></textarea></div>'
          )
        );
      } else if (item.type == "select") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%;">' +
              (item.name == null
                ? ""
                : '<h5 style="display: inline-block; margin-right: 10px;">' +
                  item.name +
                  ": </h5>") +
              '<select class="form-control confSelect" data-key="' +
              item.key +
              '" style="width: auto; display: inline-block;"><option value="choose">Choose</option>' +
              item.options
                .map(function (n) {
                  return '<option value="' + n + '">' + n + "</option>";
                })
                .join("") +
              "</select></div>"
          )
        );
      } else if (item.type == "float") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="display: inline-block; margin-right: 10px;">' +
              item.name +
              ': </h5><input class="form-control confFloat" data-key="' +
              item.key +
              '" value="" style="width: 200px; display: inline-block;"></div>'
          )
        );
      } else if (item.type == "integer") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="display: inline-block; margin-right: 10px;">' +
              item.name +
              ': </h5><input class="form-control confInteger" data-key="' +
              item.key +
              '" value="" style="width: 200px; display: inline-block;"></div>'
          )
        );
      } else if (item.type == "html") {
        printableContents.append($(item.html));
      } else if (item.type == "check") {
        printableContents.append(
          $(
            '<div style="margin-bottom: 5px;display: inline-block;width: 100%; padding: 5px; border-radius: 5px;"><input class="confCheck" type="checkbox" data-key="' +
              item.key +
              '" style="margin-right: 5px; display: inline-block;"><h5 style="display: inline; margin-right: 10px;">' +
              item.name +
              ": </h5></div>"
          )
        );
      }
    });

    printableContents.append(
      $(
        "" +
          '<div class="generalMentorCommentSection" style="margin-top: 20px;">' +
          '  <h4 style="margin-bottom: 15px;">Meeting Summary</h4>' +
          '  <div class="generalMentorCommentsText"></div>' +
          '  <textarea class="form-control generalMentorComments" style="resize: vertical; min-height: 60px;"></textarea>' +
          "</div>"
      )
    );

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success disabled" style="vertical-align: top; margin-top: 3px; display: inline-block;">Submit for Review</div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top; margin-top: 3px; display: none;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;"></h5>' +
          '  <h5 class="statusSubheader" style="display: none;">When finished, submit for review to notify your mentor</h5>' +
          "</div>"
      )
    );

    var careerErrorCheck = function () {
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: ""
      });

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess; // For managers, it's always open.

      var errors = [];
      var hasError = false;
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        var data = getKey(yearData, "data", {});
        hasError = buStructure
          .filter(function (n) {
            return ["header", "extraction", "html"].indexOf(n.type) == -1;
          })
          .some(function (item) {
            if (["string", "paragraph", "select"].indexOf(item.type) >= 0) {
              return (data["bu_" + item.key] || "").trim().length == 0;
            } else if (["float", "integer"].indexOf(item.type) >= 0) {
              return (
                data["bu_" + item.key] == null || isNaN(data["bu_" + item.key])
              );
            } else if (item.type == "check") return !data["bu_" + item.key];
            return true;
          });
      }

      if (!isOpen) {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      } else if (yearData.status == "mentee" && menteeAccess) {
        $(".statusSubheader").text(
          "When finished, submit for review to notify your mentor"
        );
        $(".errorSubheader").text(errors.join(", "));
      } else if (yearData.status == "mentor" && mentorAccess) {
        $(".statusSubheader").text("When finished, mark as finalized");
        $(".errorSubheader").text(
          "Missing information required before finalizing"
        );
      } else {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      }

      $(".statusSubheader").toggle(!hasError);
      $(".errorSubheader").toggle(hasError);

      $(".errorSubheader")
        .unbind("click")
        .click(function () {
          $(".has-error")[0].scrollIntoView();
        });
      $(".nextStatus").toggleClass("disabled", hasError);
    };

    var updateHTML = function (opts) {
      opts = opts || {};
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
      var month = cutoff.split("/")[0] || "1";
      var date = cutoff.split("/")[1] || "1";

      var startDate = new Date(month + "/" + date + "/" + viewYear).getTime();
      var endDate =
        new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
        1000 * 60 * 60 * 24;

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: "",
        details: {}
      });

      getKey(yearData, "status", "mentee"); // mentee, mentor, finalized

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess;

      var isReadOnly = function (yearData, type, thisOpts) {
        thisOpts = thisOpts || {};
        if (opts.readOnly) return true;
        var editAccessOverride =
          (user.settings.accessFilters || []).length > 0 &&
          user.settings.conferenceTabAccess == "editAccess";
        if (thisOpts.noOverride) editAccessOverride = false;
        var menteeOverride = false;
        var mentorOverride = false;

        if (viewAsState !== "undefined" && editAccessOverride) {
          editAccessOverride = false;
          if (viewAsState.career == "mentee") menteeOverride = true;
          else if (viewAsState.career == "mentor") mentorOverride = true;
          else editAccessOverride = true;
        }

        var menteeAccess =
          user.id == cvOwner.id || editAccessOverride || menteeOverride;
        var mentorAccess =
          (conference.mentors[user.id] || {})[cvOwner.id] != null ||
          editAccessOverride ||
          mentorOverride;
        return (
          !isOpen ||
          (yearData.status != type && !mentorAccess && !thisOpts.noOverride) ||
          (type == "mentee" && !menteeAccess) ||
          (type == "mentor" && !mentorAccess)
        );
      };

      $(".generalMentorCommentSection").toggle(
        isOpen &&
          (yearData.status != "mentee" ||
            mentorAccess ||
            (yearData.mentorComments || "").length > 0)
      );

      $(".statusTitle").text(
        "Status: " +
          (!isOpen
            ? "Closed"
            : {
                mentee: "Mentee Editing",
                mentor: "Mentor Review",
                finalized: "Finalized"
              }[yearData.status])
      );

      $(".nextStatus, .prevStatus").hide();
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        if (menteeAccess) $(".nextStatus").show().text("Submit for Review");
      } else if (yearData.status == "mentor") {
        if (menteeAccess && !!confYearData.open)
          $(".prevStatus").show().text("Resume Editing");
        if (mentorAccess) $(".nextStatus").show().text("Finalize Review");
      } else if (yearData.status == "finalized") {
        if (mentorAccess) $(".prevStatus").show().text("Resume Review");
      }

      var getYearText = function (obj) {
        return (
          obj.getMonth() +
          1 +
          "/" +
          obj.getDate() +
          "/" +
          (obj.getYear() + 1900 + "").slice(-2)
        );
      };
      if (isNaN(startDate)) debugger;

      $(".careerYear").html(
        "<span>" +
          getYearText(new Date(startDate)) +
          " - " +
          getYearText(new Date(endDate)) +
          "</span>" +
          (!isOpen || yearData.status == "closed"
            ? '<span class="glyphicon glyphicon-lock" style="margin-left: 10px;"></span>'
            : "")
      );

      $(".careerYearPrev")
        .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden")
        .unbind("click")
        .click(function () {
          // Only go back if previous data exists
          overviewState.yearIndex--;
          updateHTML();
        });
      $(".careerYearNext")
        .toggle(overviewState.yearIndex < availableYears.length - 1)
        .unbind("click")
        .click(function () {
          overviewState.yearIndex++;
          updateHTML();
        });

      careerErrorCheck();

      $(".nextStatus")
        .unbind("click")
        .click(function () {
          if ($(this).hasClass("disabled")) {
            $(".has-error")[0].scrollIntoView();
            return;
          }
          var yearData = newDef.career[viewYear];

          var logText = JSON.stringify({
            cvOwnerId: cvOwner.id,
            userId: user.id,
            data: newDef.career
          });
          backend.send("log", logText);
          // $.get('/log?text='+encodeURIComponent(logText));

          if (yearData.status == "mentee") {
            var check = confirm(
              "Are you sure you are ready to submit? This will send a notification to your mentor that you have completed this form."
            );
            if (!check) return;
            yearData.status = "mentor";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "mentorAlert1",
              data: {
                mentorList: mentorList,
                cvOwnerId: cvOwner.id
              }
            });
          } else if (yearData.status == "mentor") {
            var check = confirm(
              "Are you sure you are ready to finalize? This will send a notification to your mentee that you have completed this review."
            );
            if (!check) return;
            yearData.status = "finalized";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "menteeAlert1",
              data: {
                mentorId: user.id,
                cvOwnerId: cvOwner.id
              }
            });
          }
          checkSave();
          updateHTML();
        });

      $(".prevStatus")
        .unbind("click")
        .click(function () {
          if (yearData.status == "mentor") yearData.status = "mentee";
          else if (yearData.status == "finalized") yearData.status = "mentor";
          // getKey(yearData, 'statusTimes', {})[yearData.status] = Date.now();
          checkSave();
          updateHTML();
        });

      var data = getKey(yearData, "data", {});

      buStructure.map(function (item) {
        var isErr = data["bu_" + item.key] == null;
        if (["string", "float", "integer"].indexOf(item.type) >= 0) {
          if (item.type == "float") {
            isErr = isErr || isNaN(data["bu_" + item.key]);
          } else if (item.type == "int") {
            isErr = isErr || isNaN(data["bu_" + item.key]);
          } else if (item.type == "string") {
            isErr = isErr || (data["bu_" + item.key] || "").trim().length == 0;
          }
          $(
            ".conf" +
              { string: "String", float: "Float", integer: "Integer" }[
                item.type
              ] +
              '[data-key="' +
              item.key +
              '"]'
          )
            .attr("value", data["bu_" + item.key] || "")
            .val(data["bu_" + item.key] || "")
            .prop("disabled", isReadOnly(yearData, "mentee"))
            .parent()
            .toggleClass("has-error", isErr);
        } else if (item.type == "paragraph") {
          isErr = isErr || (data["bu_" + item.key] || "").trim().length == 0;

          if (item.wordLimit != null) {
            var numWords = (data["bu_" + item.key] || "")
              .split(/(?: |\n)+/)
              .filter(function (text) {
                return text.trim().length > 0;
              }).length;
            if (numWords > item.wordLimit) isErr = true;
            $('.confParagraphTitle[data-key="' + item.key + '"]')
              .text(
                item.name + ": " + numWords + "/" + item.wordLimit + " words"
              )
              .css("color", numWords > item.wordLimit ? "#ad310e" : "");
          }

          $('.confParagraph[data-key="' + item.key + '"]')
            .val(data["bu_" + item.key] || "")
            .prop("disabled", isReadOnly(yearData, "mentee"))
            .parent()
            .toggleClass("has-error", isErr);
        } else if (item.type == "check") {
          isErr = isErr || !data["bu_" + item.key];
          $('.confCheck[data-key="' + item.key + '"]')
            .prop("disabled", isReadOnly(yearData, "mentee"))
            .prop("checked", !!data["bu_" + item.key])
            .parent()
            .css("border", isErr ? "2px solid #a94442" : "");

          if (data["bu_" + item.key])
            $('.confCheck[data-key="' + item.key + '"]').attr(
              "checked",
              "true"
            );
          else
            $('.confCheck[data-key="' + item.key + '"]').removeAttr("checked");
        } else if (item.type == "select") {
          if (item.options.indexOf(data["bu_" + item.key]) == -1)
            delete data["bu_" + item.key];
          var selectEl = $('.confSelect[data-key="' + item.key + '"]');
          selectEl
            .prop("disabled", isReadOnly(yearData, "mentee"))
            .val(data["bu_" + item.key] || "choose")
            .parent()
            .toggleClass("has-error", isErr);
          selectEl.find("option").attr("selected", false);
          selectEl
            .find(
              'option[value="' + (data["bu_" + item.key] || "choose") + '"]'
            )
            .attr("selected", true);
        } else if (item.type == "exclusion") {
          var extracted = item.val(newDef);
          $('.confExtraction[data-key="' + item.key + '"]')
            .text(extracted.text)
            .parent()
            .attr("data-field", extracted.field)
            .attr("data-id", extracted.i);
        }
      });

      var outputSource = formats[format];
      if (formats[format].outputs != null) {
        var outputNames = keys(formats[format].outputs);
        if (outputNames.indexOf($("#cvOutputFormat").val()) >= 0)
          outputSource = formats[format].outputs[$("#cvOutputFormat").val()];
        else outputSource = formats[format].outputs[outputNames[0]];
      }

      $("#buConfPreview").empty();
      cvOutputData(
        newDef,
        {
          id: cvId,
          cvOwner,
          type: "partial",
          start: { month, year: viewYear },
          end: { month, year: viewYear + 1 },
          filter: function (time) {
            return isTimeWithinRange(time, startDate, endDate);
          },
          noXML: true,
          formats,
          preview: true,
          contextState,
          outputSource,
          custom: { dateLimited: true }
        },
        function (limitedData) {
          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 20px;font-weight: bold;">CV Content from ' +
                getYearText(new Date(startDate)) +
                " - " +
                getYearText(new Date(endDate)) +
                "</h5>"
            )
          );

          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">RESEARCH / GRANTS</h5>'
            )
          );
          if (!limitedData["osSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("osSections", ["t", "1"])(limitedData))
          );

          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">Publications ( all categories )</h5>'
            )
          );
          if (!limitedData["shSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("shSections", ["1", "2"])(limitedData))
          );

          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">Regional/national presentations</h5>'
            )
          );
          if (!limitedData["lecSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("lecSections", ["t", "1"])(limitedData))
          );
          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">Regional/national awards</h5>'
            )
          );
          if (!limitedData["honSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("honSections", ["t", "1"])(limitedData))
          );

          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">Editorial (both ad hoc reviewing and editorial board content)</h5>'
            )
          );
          if (!limitedData["edSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("edSections", ["t", "1"])(limitedData))
          );

          // From "Departmental, School and University Committees", "Professional Societies", and "Major Committee Assignments"
          $("#buConfPreview").append(
            $(
              '<h5 style="margin-bottom: 15px; font-weight: bold; text-decoration: underline;">Hospital/medical center committee/service, Regional/national leadership positions, and Major Committee Assignments</h5>'
            )
          );
          limitedData["noComSocOrMcSection"] =
            !limitedData["comSection"] &&
            !limitedData["socSection"] &&
            !limitedData["mcSection"];
          if (limitedData["noComSocOrMcSection"])
            $("#buConfPreview").append(
              $('<p style="margin-bottom: 15px;">None in Date Range</p>')
            );
          $("#buConfPreview").append(
            $(previewSections("comSections", ["t", "1"])(limitedData))
          );
          $("#buConfPreview").append(
            $(previewSections("socSections", ["t", "1"])(limitedData))
          );
          $("#buConfPreview").append(
            $(previewSections("mcSections", ["t", "1"])(limitedData))
          );
        }
      );

      $(".confCheck")
        .unbind("change")
        .on("change", function () {
          var key = getProp(this, "key");
          var tf = $(this).is(":checked");
          var data = newDef.career[viewYear].data;
          data["bu_" + key] = tf;

          var isErr = !tf;
          $(this)
            .parent()
            .css("border", isErr ? "2px solid #a94442" : "");

          var logText =
            "q - " + key + " - tf - " + tf + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".confString")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var text = $(this).val();
          var data = newDef.career[viewYear].data;

          var isErr = text == null || text.trim().length == 0;
          $(this).parent().toggleClass("has-error", isErr);
          if (isErr) text = null;

          data["bu_" + key] = text;

          var logText =
            "q - " + key + " - text - " + text + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".confParagraph")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var text = $(this).val();
          var data = newDef.career[viewYear].data;

          var isErr = text == null || text.trim().length == 0;
          if (isErr) text = null;

          var item = buStructure.find(function (n) {
            return n.key == key;
          });
          if (item?.wordLimit != null) {
            var numWords = (text || "")
              .split(/(?: |\n)+/)
              .filter(function (text) {
                return text.trim().length > 0;
              }).length;
            if (numWords > item.wordLimit) isErr = true;
            $(this)
              .parent()
              .find(".confParagraphTitle")
              .text(
                item.name + ": " + numWords + "/" + item.wordLimit + " words"
              )
              .css("color", numWords > item.wordLimit ? "#ad310e" : "");
          }

          $(this).parent().toggleClass("has-error", isErr);
          data["bu_" + key] = text;

          var logText =
            "q - " + key + " - text - " + text + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".confSelect")
        .unbind("change")
        .on("change", function () {
          var key = getProp(this, "key");
          var text = $(this).val();
          if (text == "choose") text = null;

          var isErr = text == null;
          $(this).parent().toggleClass("has-error", isErr);
          if (isErr) text = null;

          var data = newDef.career[viewYear].data;
          data["bu_" + key] = text;

          var logText =
            "q - " + key + " - select - " + text + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".confFloat")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var float = parseFloat($(this).val());

          var isErr = isNaN(float);
          $(this).parent().toggleClass("has-error", isErr);
          if (isErr) float = null;

          var data = newDef.career[viewYear].data;
          data["bu_" + key] = float;

          var logText =
            "q - " + key + " - float - " + float + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".confInteger")
        .unbind("input")
        .on("input", function () {
          var key = getProp(this, "key");
          var int = parseInt($(this).val());

          var isErr =
            isNaN(int) || parseFloat($(this).val()) != parseInt($(this).val());
          $(this).parent().toggleClass("has-error", isErr);
          if (isErr) int = null;

          var data = newDef.career[viewYear].data;
          data["bu_" + key] = int;

          var logText =
            "q - " + key + " - int - " + int + " - user " + (user || {}).id;
          backend.send("log", logText);
          careerErrorCheck();
          checkSave();
        });

      $(".generalMentorComments")
        .toggle(!isReadOnly(yearData, "mentor"))
        .val(getKey(yearData, "mentorComments", ""))
        .parent()
        .toggleClass(
          "has-error",
          !isReadOnly(yearData, "mentor") &&
            (yearData.mentorComments || "").length == 0
        );

      $(".generalMentorCommentsText")
        .toggle(isReadOnly(yearData, "mentor"))
        .html(getKey(yearData, "mentorComments", "").split("\n").join("<br>"));

      $(".generalMentorComments")
        .unbind("input")
        .on("input", function () {
          var yearData = newDef.career[viewYear];
          yearData.mentorComments = $(this).val().trim();
          $(this)
            .parent()
            .toggleClass("has-error", yearData.mentorComments.length == 0);
          checkSave();
          careerErrorCheck();
        });

      updateLayout();
    };

    updateHTML();
  },
  manageSetup: function (
    settingsEl,
    { conference, updateConfDate, saveConference, hierarchyNames },
    user
  ) {
    const ccManage = new CCManage(conference, saveConference, updateConfDate, {
      includeSections: {
        cutoff: true,
        mentees: true,
        goals: false,
        questions: false,
        mentors: true,
        reminders: false,
        years: true
      },
      sortBy: "mentor",
      verbage: {
        mentor: "Mentor",
        mentee: "Mentee"
      }
    });
    ccManage.createSettingsElements(settingsEl);
    updateConfDate(conference);
    ccManage.createMentorsMenteesSection();
    ccManage.createAwesomplete();
    ccManage.hookMessageButton(user);
    ccManage.populateMenteesSection(hierarchyNames);
  }
};
